module.exports = __webpack_public_path__ + "static/media/bell.c472c01e.svg";